import { RoulettePrizeProps } from './props';
import styles from './styles.module.scss';

export default function RoulettePrize<T>({
  customCard,
  data,
  position,
}: RoulettePrizeProps<T>) {
  if (typeof customCard != 'undefined') {
    return customCard(data, position);
  }

  return <div className={styles.card}>{position}</div>;
}
